export enum ActivationStatuses {
  ACTIVATE_SIM = 'activate_sim', // Activate SIM
  ACTIVATION_REQUESTED = 'activation_requested', // Activation requested
  AWAITING_ACTIVATION = 'activation_pending', // Awaiting activation
  ACTIVATION_FAILED = 'activation_failed', // Activation failed
}

export enum SignUpStatuses {
  SETUP = 'sign_up_setup', // Setup
  PENDING = 'sign_up_pending', // Invitation sent
  COMPLETED = 'sign_up_completed', // Invitation accepted
}

export enum MemberDashboardStatuses {
  PAUSE_SCHEDULED = 'pause_scheduled',
  ACTIVE = 'active',
}

export enum PostActivationStatuses {
  PAUSE_SCHEDULED = 'pause_scheduled',
  PAUSED = 'paused',
  ACTIVE = 'active',
  PLAN_CHANGE_PENDING = 'plan_change_pending',
  EXPIRED = 'expired',
}

export enum StatusesAllowedForLinkToProfile {
  PAUSE_SCHEDULED = 'pause_scheduled',
  PAUSED = 'paused',
  ACTIVE = 'active',
}

export type Statuses =
  | ActivationStatuses
  | SignUpStatuses
  | PostActivationStatuses

export type Member = {
  customer_id: number
  customer_ref: string
  group_member_id: number
  is_owner: boolean
  is_member: boolean
  first_name: string
  last_name: string
  nickname: 'device' | 'under_16' | null
  email: string | null
  msisdn: string
  invitation_sent_at?: string
  member_sorting_order: number
  status: Statuses
}

export enum StatusColor {
  GREY = 'grey',
  GREEN = 'green',
  BLUE = 'blue',
  ORANGE = 'orange',
  YELLOW = 'yellow',
}

export interface PortInPoolItem extends FamilyPortInDetails {
  id: number | string
}

export interface FamilyPortInDetails {
  name: string
  msisdn: string
  code: string
  switch_date?: string
  code_expiration: string
}

export interface FamilyPortInPool {
  hasFetched: boolean
  isFetching: boolean
  data: PortInPoolItem[] | null
  newNumbers: PortInPoolItem[]
  error: string | null
}

export type PortInValidatePoolItemPayload = {
  msisdn: string
  pac_code: string
  requested_switch_date?: string
}

export type PortInPoolItemValidation = {
  switch_date: string
  code_expiry_date: string
}
